import {
  AddCircle24Filled,
  AddCircle24Regular,
  AddSquare20Regular,
  AddSquare24Filled,
  AddSquare24Regular,
  Alert24Filled,
  Alert24Regular,
  AnimalPawPrint24Filled,
  AnimalPawPrint24Regular,
  AppFolder24Filled,
  AppFolder24Regular,
  Apps20Filled,
  Apps20Regular,
  Apps24Filled,
  Apps24Regular,
  ArrowRight24Filled,
  Attach20Filled,
  Attach20Regular,
  Backpack24Filled,
  Backpack24Regular,
  BeakerEdit24Filled,
  BeakerEdit24Regular,
  BookContacts24Filled,
  BookContacts24Regular,
  CalendarError24Filled,
  CalendarError24Regular,
  CalendarLtr20Filled,
  CalendarLtr20Regular,
  CalendarLtr24Filled,
  CalendarLtr24Regular,
  Call24Filled,
  Call24Regular,
  Chat24Filled,
  Chat24Regular,
  ChatHelp20Filled,
  ChatHelp20Regular,
  Collections20Filled,
  Collections20Regular,
  Compose20Regular,
  ContentView20Filled,
  ContentView20Regular,
  Document24Filled,
  Document24Regular,
  DocumentCatchUp20Filled,
  DocumentCatchUp20Regular,
  DocumentOnePageMultiple24Filled,
  DocumentOnePageMultiple24Regular,
  Eye20Regular,
  Feed24Filled,
  Feed24Regular,
  Flowchart24Filled,
  Flowchart24Regular,
  Folder24Filled,
  Folder24Regular,
  Glance24Filled,
  Glance24Regular,
  Guest24Filled,
  Guest24Regular,
  Home24Filled,
  Home24Regular,
  Info20Regular,
  Library24Filled,
  Library24Regular,
  Mail20Filled,
  Mail20Regular,
  Megaphone20Filled,
  Megaphone20Regular,
  MoreHorizontal24Filled,
  MoreHorizontal24Regular,
  MountainTrail24Filled,
  MountainTrail24Regular,
  News24Filled,
  News24Regular,
  Open24Regular,
  Organization20Filled,
  Organization20Regular,
  Pen24Filled,
  Pen24Regular,
  People20Filled,
  People20Regular,
  People24Filled,
  People24Regular,
  PeopleCommunity20Filled,
  PeopleCommunity20Regular,
  PeopleTeam24Filled,
  PeopleTeam24Regular,
  PersonFeedback24Filled,
  PersonFeedback24Regular,
  PersonSupport24Filled,
  PersonSupport24Regular,
  Phone20Filled,
  Phone20Regular,
  Pin20Regular,
  PinOff20Regular,
  PresenceBlocked20Regular,
  Prohibited20Regular,
  QuestionCircle24Filled,
  QuestionCircle24Regular,
  Search20Filled,
  Search20Regular,
  Search24Filled,
  Search24Regular,
  Settings20Regular,
  Share20Regular,
  SlideLayout24Filled,
  SlideLayout24Regular,
  SlideSearch24Filled,
  SlideSearch24Regular,
  TaskListLtr20Filled,
  TaskListLtr20Regular,
  TasksApp20Filled,
  TasksApp20Regular,
  TextBulletListSquare24Filled,
  TextBulletListSquare24Regular,
  Video24Filled,
  Video24Regular,
  VideoClipMultiple24Filled,
  VideoClipMultiple24Regular,
  WindowNew24Regular,
  type FluentIconsProps,
} from "@fluentui/react-icons";
import React from "react";
import { Notebooks, NotebooksFilled } from "./icons/Notebooks";
import { Pages24Filled, Pages24Regular } from "./icons/Pages";
import { Teach24Filled, Teach24Regular } from "./icons/Teach";

export type IconSize = "default" | "wide";

export interface AppBarIconProps {
  size: IconSize;
}
export const MoreIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(MoreHorizontal24Regular, props);
};

export const MoreIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(MoreHorizontal24Filled, props);
};

export const HomeIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Home24Regular, props);
};

export const HomeIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Home24Filled, props);
};

export const CreateIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddCircle24Regular, props);
};

export const CreateIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddCircle24Filled, props);
};

export const HelpIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(QuestionCircle24Regular, props);
};

export const HelpIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(QuestionCircle24Filled, props);
};

export const CopilotBoardsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Flowchart24Regular, props);
};

export const CopilotBoardsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Flowchart24Filled, props);
};

export const LibraryIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Library24Regular, props);
};

export const LibraryIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Library24Filled, props);
};

export const CreateIconPen = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Pen24Regular, props);
};

export const CreateIconPenSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Pen24Filled, props);
};

export const ClipsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(VideoClipMultiple24Regular, props);
};

export const ClipsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(VideoClipMultiple24Filled, props);
};

export const TeachIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Teach24Regular, props);
};

export const TeachIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Teach24Filled, props);
};

export const FeedbackIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PersonFeedback24Regular, props);
};

export const FeedbackIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PersonFeedback24Filled, props);
};

export const MyContentIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Folder24Regular, props);
};

export const MyContentIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Folder24Filled, props);
};

export const PrepareIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(TextBulletListSquare24Regular, props);
};

export const PrepareIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(TextBulletListSquare24Filled, props);
};

export const WorkplaceIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Guest24Regular, props);
};

export const WorkplaceIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Guest24Filled, props);
};

export const CatchUpIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Glance24Regular, props);
};

export const CatchUpIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Glance24Filled, props);
};

export const CollectIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(DocumentOnePageMultiple24Regular, props);
};

export const PagesIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Pages24Regular, props);
};

export const NotebooksIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Notebooks, props);
};

export const NotebooksFilledIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(NotebooksFilled, props);
};

export const CollectIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(DocumentOnePageMultiple24Filled, props);
};

export const PagesIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Pages24Filled, props);
};

export const NewsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(News24Regular, props);
};

export const NewsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(News24Filled, props);
};

export const CatchupIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(DocumentCatchUp20Regular, props);
};

export const CatchupIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(DocumentCatchUp20Filled, props);
};

export const AssistIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(ChatHelp20Regular, props);
};

export const AssistIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(ChatHelp20Filled, props);
};
export const ArrowRightIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(ArrowRight24Filled, props);
};

export const ActivityIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Alert24Regular, props);
};

export const ActivityIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Alert24Filled, props);
};

export const ChatIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Chat24Regular, props);
};

export const ChatIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Chat24Filled, props);
};

export const AiHubSampleIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(BeakerEdit24Regular, props);
};
export const AiHubSampleIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(BeakerEdit24Filled, props);
};

export const TeamsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PeopleTeam24Regular, props);
};

export const TeamsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PeopleTeam24Filled, props);
};

export const TeamsCalendarIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(CalendarLtr24Regular, props);
};

export const TeamsCalendarIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(CalendarLtr24Filled, props);
};

export const TeamsCalendarErrorIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(CalendarError24Regular, props);
};

export const TeamsCalendarErrorIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(CalendarError24Filled, props);
};

export const CallsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Call24Regular, props);
};

export const CallsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Call24Filled, props);
};

export const PersonSupportIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PersonSupport24Regular, props);
};

export const PersonSupportIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PersonSupport24Filled, props);
};

export const FilesIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Document24Regular, props);
};

export const FilesIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Document24Filled, props);
};

export const MeetIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Video24Regular, props);
};

export const MeetIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Video24Filled, props);
};

export const MailIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Mail20Regular, props);
};

export const MailIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Mail20Filled, props);
};

export const OutlookCalendarIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(CalendarLtr20Regular, props);
};

export const OutlookCalendarIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(CalendarLtr20Filled, props);
};

export const PeopleIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(People20Regular, props);
};

export const PeopleIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(People20Filled, props);
};

export const TeamsBookContactsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(BookContacts24Regular, props);
};

export const TeamsBookContactsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(BookContacts24Filled, props);
};

export const TeamsPeopleIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(People24Regular, props);
};

export const TeamsPeopleIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(People24Filled, props);
};

export const OutlookGroupsIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PeopleCommunity20Regular, props);
};

export const OutlookGroupsIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PeopleCommunity20Filled, props);
};

export const OutlookFilesIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Attach20Regular, props);
};

export const OutlookFilesIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Attach20Filled, props);
};

export const OutlookToDoIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(TaskListLtr20Regular, props);
};

export const OutlookToDoIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(TaskListLtr20Filled, props);
};

export const OutlookTasksIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(TasksApp20Regular, props);
};

export const OutlookTasksIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(TasksApp20Filled, props);
};

export const OutlookSpacesIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Collections20Regular, props);
};

export const OutlookSpacesIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Collections20Filled, props);
};

export const OutlookEventifyIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Megaphone20Regular, props);
};

export const OutlookEventifyIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Megaphone20Filled, props);
};

export const OutlookOrgExplorerIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Organization20Regular, props);
};

export const OutlookOrgExplorerIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Organization20Filled, props);
};

export const StoreIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AppFolder24Regular, props);
};

export const StoreIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AppFolder24Filled, props);
};

export const AppsIcon = (
  props: FluentIconsProps & AppBarIconProps
): React.ReactElement | null => {
  return props.size === "default"
    ? React.createElement(Apps20Regular, props)
    : React.createElement(Apps24Regular, props);
};

export const AppsIconSelected = (
  props: FluentIconsProps & AppBarIconProps
): React.ReactElement | null => {
  return props.size === "default"
    ? React.createElement(Apps20Filled, props)
    : React.createElement(Apps24Filled, props);
};

export const FeedIcon = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Feed24Regular, props);
};

export const FeedIconSelected = (
  props: React.HTMLAttributes<SVGElement> & FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Feed24Filled, props);
};

export const AppsIcon20 = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Apps20Regular, props);
};

export const AppGalleryIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddSquare24Regular, props);
};

export const AppGalleryIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddSquare24Filled, props);
};

export const AddSquareIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddSquare20Regular, props);
};

export const TeamsStoreIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddSquare24Regular, props);
};

export const TeamsStoreIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AddSquare24Filled, props);
};

export const OutlookPhoneIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Phone20Regular, props);
};

export const OutlookPhoneIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Phone20Filled, props);
};

export const OutlookNewslettersIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(ContentView20Regular, props);
};

export const OutlookNewslettersIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(ContentView20Filled, props);
};

export const PinIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Pin20Regular, props);
};

export const PinOffIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PinOff20Regular, props);
};

export const SearchIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Search20Regular, props);
};

export const SearchIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Search20Filled, props);
};

export const SearchModuleIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Search24Regular, props);
};

export const SearchModuleIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Search24Filled, props);
};

export const AIViewsPlaygroundModuleIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(SlideLayout24Regular, props);
};

export const AIViewsPlaygroundModuleIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(SlideLayout24Filled, props);
};

export const SettingsIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Settings20Regular, props);
};

export const AssignmentsIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Backpack24Regular, props);
};

export const AssignmentsIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Backpack24Filled, props);
};

export const PresenceBlockedIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(PresenceBlocked20Regular, props);
};

export const ProhibitIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Prohibited20Regular, props);
};

export const EyeIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Eye20Regular, props);
};

export const ShareGenericIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Share20Regular, props);
};

export const ComposeIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Compose20Regular, props);
};

export const InfoIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Info20Regular, props);
};

export const PopupIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(WindowNew24Regular, props);
};

export const OpenIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(Open24Regular, props);
};

export const AlpsIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(MountainTrail24Regular, props);
};

export const AlpsIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(MountainTrail24Filled, props);
};

export const BrowseIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(SlideSearch24Regular, props);
};

export const BrowseIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(SlideSearch24Filled, props);
};

export const ExperimentModuleIcon = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AnimalPawPrint24Regular, props);
};

export const ExperimentModuleIconSelected = (
  props: FluentIconsProps
): React.ReactElement<any, any> | null => {
  return React.createElement(AnimalPawPrint24Filled, props);
};
